import { render, staticRenderFns } from "./StepsCreator.vue?vue&type=template&id=81ad2d3c&scoped=true&"
import script from "./StepsCreator.ts?vue&type=script&lang=ts&"
export * from "./StepsCreator.ts?vue&type=script&lang=ts&"
import style0 from "./StepsCreator.scss?vue&type=style&index=0&id=81ad2d3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad2d3c",
  null
  
)

export default component.exports